import React from 'react';
import Footer from '../../Footer';
import {Route, Switch} from 'react-router';
import routes from '../../../routes';
import Header from '../../Header';
import EventListener from 'react-event-listener';
import Localization from '../views/localization.c';
import Notifications from '../views/notifications.c';
import Session from '../../Session';
import Help from '../../Help';
import Confirm from '../../CustomComponents/confirm';

export default function template() {
    const model = this.getModel(),
        {logout} = this.props;

    let logoutContent = null;

    const routeList = routes.map(route => {
        return (
            <Route
                exact={true}
                path={route.path}
                render={props =>
                    React.createElement(route.component, {...this.commonProps(), ...props})
                }
                key={route.id}
            />
        );
    });

    if (logout) {
        logoutContent = (
            <Confirm onSubmit={this._logout} onCancel={this._hideLogout}>
                {this.l10n('APP_CONFIRM_LOGOUT')}
            </Confirm>
        );
    }

    return (
        <React.Fragment>
            {logoutContent}
            <div className="module-app">
                <Session {...this.props}>
                    <Localization {...this.props} model={model}>
                        <Notifications>
                            <EventListener target={window} onResize={this._handleWindowResize} />
                            <Header {...this.commonProps()} />
                            <section className="module-content">
                                <Switch>{routeList}</Switch>
                            </section>
                            <Footer {...this.commonProps()} />
                        </Notifications>
                    </Localization>
                </Session>
            </div>
        </React.Fragment>
    );
}
